<template>
  <ul>
    <li class="first-page" :class="{ disabled: currentPage == 1 }">
      <a href="javascript:;" @click="() => {currentPage == 1 ? null : setPage(1)}">最初</a>
    </li>
    <li class="prev-page" :class="{ disabled: currentPage == 1 }">
      <a href="javascript:;" @click="() => {currentPage == 1 ? null : setPage(currentPage - 1)}">前へ</a>
    </li>
    <li
      v-for="page in pager.pages"
      :key="page"
      :class="[currentPage === page ? 'number-page-active' : 'number-page']"
    >
      <a href="javascript:" @click="setPage(page)">{{ page }}</a>
    </li>
    <li class="next-page" :class="{ disabled: currentPage == totalPages }">
      <a href="javascript:;"  @click="() => {currentPage == totalPages ? null : setPage(currentPage + 1)}">次へ</a>
    </li>
    <li class="last-page" :class="{ disabled: currentPage == totalPages }">
      <a href="javascript:;" @click="() => {currentPage == totalPages ? null : setPage(totalPages)}">最後</a>
    </li>
  </ul>
</template>

<script>
import paginate from "jw-paginate"
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      pager: {}
    }
  },
  watch: {
    totalPages() {
      this.pager = paginate(this.totalPages, this.currentPage, 1, 4)
    }
  },
  created() {
    this.setPage(1)
  },
  methods: {
    setPage(page) {
      this.pager = paginate(this.totalPages, page, 1, 4)
      this.$emit("changePage", page)
    }
  },
}
</script>